import { Box } from "@chakra-ui/react";
import { customEvent } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";
import { FilterKey, FILTERS } from "../constants/contentData";

interface ContentFilterSectionProps {
  selectedFilter: FilterKey | null;
  onSelect: (key: FilterKey | null) => void;
}

export default function ContentFilterSection({
  selectedFilter,
  onSelect,
}: ContentFilterSectionProps) {
  return (
    <BaseStack spacing={16} px={20} pt={24} pb={0}>
      <Box className="title_3_b" style={{ color: "#171819" }}>
        어떤 고민이 있으신가요?
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "6px",
          paddingBottom: "20px",
        }}
      >
        {FILTERS.map(({ key, label }) => {
          const isSelected = selectedFilter === key;
          return (
            <Box
              key={key}
              as="button"
              style={{
                padding: "4px 10px",
                borderRadius: "6px",
                background: isSelected ? "#171819" : "#f4f5f6",
                color: isSelected ? "#ffffff" : "#171819",
                cursor: "pointer",
                fontSize: "15px",
                fontWeight: 500,
                lineHeight: "22px",
                letterSpacing: "-0.3px",
                border: "none",
                flexShrink: 0,
              }}
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "content",
                    trigger_and_target: `filter_${key}`,
                  },
                });
                onSelect(key);
              }}
            >
              {label}
            </Box>
          );
        })}
      </Box>
      <Box width="100%" height="1px" background="#e8e9ea" />
    </BaseStack>
  );
}
